import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Professional breadcrumb navigation component
 * Shows hierarchical path: Dashboard > Module > SubModule > Item
 */
const Breadcrumbs = ({ customItems }) => {
  const location = useLocation();

  // Generate breadcrumbs from URL path
  const generateBreadcrumbs = () => {
    if (customItems) return customItems;

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Dashboard', path: '/dashboard' }];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;

      // Format label (capitalize and replace hyphens)
      const label = segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      // Don't add if it's just a number (likely an ID)
      if (!/^\d+$/.test(segment)) {
        breadcrumbs.push({
          label,
          path: currentPath,
          isLast: index === pathSegments.length - 1
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <nav className="flex items-center gap-2 px-6 py-3 bg-white dark:bg-dark-900 border-b border-gray-200 dark:border-dark-700 text-sm">
      <Link
        to="/dashboard"
        className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
      >
        <Home size={16} />
      </Link>

      {breadcrumbs.slice(1).map((crumb, _index) => (
        <div key={crumb.path} className="flex items-center gap-2">
          <ChevronRight size={16} className="text-gray-400 dark:text-gray-600" />
          {crumb.isLast ? (
            <span className="font-medium text-brand-600 dark:text-brand-400">
              {crumb.label}
            </span>
          ) : (
            <Link
              to={crumb.path}
              className="text-gray-600 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
            >
              {crumb.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
